<template lang="pug">
.tabs
  q-tabs(:value="currentTab", align="left")
    q-tab(
      v-for="tab in tabs",
      :key="tab.id",
      @click="setCurrentTab(tab.id)",
      :name="tab.id",
      :label-slot="false",
      :style="getTabStyle()"
    )
      template(v-if="tab.icon", slot="default")
        inline-svg(:src="require(`../../../../assets/icons/ppr/equipment/show/${tab.icon}`)")
      template(v-if="tab.label", slot="default")
        span {{ tab.label }}

  q-tab-panels(:value="currentTab")
    q-tab-panel(v-for="tab in tabs", :key="tab.id", :name="tab.id")
      section(v-for="section in tab.sections", :key="section.id")
        component(
          :is="sectionComponents[section.type]",
          :data="section",
          :rowId="rowId",
          @open-print-act="openPrintAct",
          @reload-show-ui="reloadShowUi",
          @open-edit="openEdit",
          @open-issue-form="openIssueForm",
          @copy-row-item="copyRowItem",
          @show-checklist="showChecklist"
        )
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import backend from "@/api";
import { handleError } from "@/services/handleErrors";
import sectionComponents from "./sections/index.js";

const props = defineProps({
  /** Табы переданные от родителя */
  tabs: { type: Array, default: () => [] },
  /** id текущего выбранного ряда. Нужен для обновления текущего ряда при изменении. Пример: 1 */
  rowId: { type: null || Number, default: null },
});

const emit = defineEmits([
  /** Используется для печати акта. Принимает дату для печати акта */
  "open-print-act",
  /** Используется для сброса даты текущего show компонента. Не принимает параметры */
  "reload-show-ui",
  /** Эмит открытия edit-формы текущей записи. */
  "open-edit",
  /** Эмит копирования элемента. В качестве параметра принимает id исходного элемента. Пример: 1 */
  "copy-row-item",
  /** Эмит для открытия формы создания заявки из обращения */
  "open-issue-form",
  /** Эмит копирования элемента. В качестве параметра принимает id исходного элемента. Пример: 1 */
  "copy-row-item",
  /** Эмит открытия предпросмотра чеклиста. В качестве параметра принимает action с data_url. */
  "show-checklist",
]);

const tabs = computed(() => props.tabs);
const rowId = computed(() => props.rowId);
const currentTab = ref(tabs.value[0].id);

const getTabStyle = () => {
  return {
    width: `calc(100% / ${tabs.value.length})`,
  };
};

const setCurrentTab = tab => {
  currentTab.value = tab;
};

const openPrintAct = data => {
  emit("open-print-act", data);
};

const reloadShowUi = () => {
  emit("reload-show-ui");
};

const openEdit = id => {
  emit("open-edit", id);
};

const openIssueForm = id => {
  emit("open-issue-form", id);
};

const copyRowItem = id => {
  emit("copy-row-item", id);
};

const showChecklist = handler => {
  emit("show-checklist", handler);
};
</script>

<style scoped lang="scss">
.tabs {
  width: 100%;

  section {
    margin-top: 22px;
  }
}
</style>
